import { useEffect } from 'react';
import { createUseStyles } from '@pushpay/styles';
export const useStyles = createUseStyles(theme => ({
  root: ({
    width,
    height
  }) => ({
    width: typeof width === 'number' ? `${width}px` : width,
    height: typeof height === 'number' ? `${height}px` : height,
    transition: `opacity ${theme.DURATIONS.SHORT}, width ${theme.DURATIONS.MEDIUM}, height ${theme.DURATIONS.MEDIUM}`
  }),
  loading: {
    opacity: 0
  },
  loaded: {
    opacity: 1
  }
}));
export const imageLoadListener = (imageLoader, elem, src, setIsLoaded, resizeOnLoaded, onImageDisplayed) => {
  return () => {
    if (elem.current) {
      // eslint-disable-next-line no-param-reassign
      elem.current.src = src;

      if (resizeOnLoaded) {
        // eslint-disable-next-line no-param-reassign
        elem.current.style.width = `${imageLoader.width}px`; // eslint-disable-next-line no-param-reassign

        elem.current.style.height = `${imageLoader.height}px`;
      }
    }

    if (onImageDisplayed) {
      onImageDisplayed();
    }

    setIsLoaded(true);
  };
};
export function useImageLoaded(imgRef, isLoaded, targetId) {
  useEffect(() => {
    if (!isLoaded || !imgRef.current) return;
    const loadedAttribute = `data-${targetId}-loaded`;

    if (!imgRef.current.hasAttribute(loadedAttribute)) {
      imgRef.current.setAttribute(loadedAttribute, '');
    }
  }, [imgRef.current, isLoaded, targetId]);
}